<ng-container *ngIf="customerData">
  <div class="bg-full-image" [id]="currentAccountType === '3a' ? 'poppy-wrap' : ''">
    <section id="funding">
      <div class="flex-container">
        <div class="flex-row flex-justify-center">
          <div class="flex-col-4 flex-col-md-12 flex-col-sm-12">
            <!-- Account is being opened (pending fund) -->
            <div *ngIf="!accountOpened">
              <div class="title-box">
                <h2>
                  {{ (currentAccountType === '3a' ? 'steps.id5.account_to_fund.title-3a' : 'steps.id5.account_to_fund.title') | translate }}
                </h2>
              </div>

              <app-fund-list-icons [currentAccountType]="currentAccountType"></app-fund-list-icons>

              <div class="summary" *ngIf="currentAccountType !== '3a' && currentAccountType !== 'grow'">
                <h2>{{ 'steps.id5.account_to_fund.meanwhile_title' | translate }}</h2>
                <ng-container *ngIf="currentAccount.kind === 'kid'; else showNormalWaitingBox">
                  <app-fund-kids-form [firstName]="currentAccount.owner_name"></app-fund-kids-form>
                </ng-container>
                <ng-template #showNormalWaitingBox>
                  <div class="more-box">
                    <div [innerHTML]="'steps.id5.account_to_fund.meanwhile_text_p1' | translate"></div>
                    <button (click)="onOpenStrategy(customerData.hide_personalisation)" class="ui-button secondary full-width">
                      {{ 'steps.id5.account_to_fund.check_strategy_button' | translate }}
                    </button>
                    @if (!customerData.hide_personalisation) {
                      <div [innerHTML]="'steps.id5.account_to_fund.meanwhile_text_p2' | translate"></div>
                      <button (click)="onOpenStrategy(true)" class="ui-button secondary full-width">
                        {{ 'steps.id5.account_to_fund.change_investment_sum_button' | translate }}
                      </button>
                    }
                  </div>
                </ng-template>
              </div>

              <div *ngIf="customerData">
                <ng-container *ngIf="currentAccountType === '3a'; else otherAccounts">
                  <div *ngIf="isTransfer3AOnly">
                    <p class="transfer-note-3a">{{ 'steps.id5.account_to_fund.note-3a' | translate }}</p>
                  </div>

                  <app-fund-3a-contribution-level-header
                    *ngIf="!isTransfer3AOnly"
                    [accountOpened]="accountOpened"
                    [currentYear]="currentYear"
                    [maximumContributionLevel]="maximumContributionLevel"
                    [maximumContributionAmount]="maximumContributionAmount"
                    [showUnemployed3ANote]="showUnemployed3ANote"
                    [customerData]="customerData"
                    [currentAccount]="currentAccount"
                  ></app-fund-3a-contribution-level-header>

                  <app-fund-3a-infobox [contribution]="maximumContributionLevel"></app-fund-3a-infobox>
                </ng-container>
                <ng-template #otherAccounts>
                  <!-- Summary -->
                  <app-fund-summary
                    [customerData]="customerData"
                    [currentAccountDetails]="currentAccount"
                    [accountOpened]="accountOpened"
                    [oneTimeInvested]="oneTimeInvested"
                    [monthlyInvested]="monthlyInvested"
                    [iban]="iban"
                  ></app-fund-summary>
                </ng-template>
              </div>

              <div *ngIf="currentAccountType !== '3a'">
                <p>
                  {{ 'steps.id5.account_to_fund.questions' | translate }}{{ ' ' }}
                  <a (click)="router.navigateByUrl('/help')">{{ 'contact.link' | translate }}</a>
                </p>
              </div>
            </div>

            <!-- Account is successfully opened (No pending fund) -->
            <div *ngIf="accountOpened">
              <div class="title-box">
                <h2>
                  {{ (currentAccountType === '3a' ? 'steps.id5.account_funded.title-3a' : 'steps.id5.account_funded.title') | translate }}
                </h2>
                <p *ngIf="currentAccountType !== '3a'">{{ 'steps.id5.account_funded.p' | translate }}</p>

                <div class="doc-notification info" *ngIf="currentAccountType === '3a'">
                  <span class="icon-i-info"></span>
                  <p>{{ 'steps.id5.account_funded.infobox_liberty' | translate }}</p>
                </div>

                <p *ngIf="currentAccountType === '3a' && isTransfer3AOnly">
                  {{ 'steps.id5.account_to_fund.note-3a' | translate }}
                </p>
              </div>

              <!-- Summary -->
              <app-fund-summary
                *ngIf="customerData && currentAccountType !== '3a'"
                [customerData]="customerData"
                [currentAccountDetails]="currentAccount"
                [accountOpened]="accountOpened"
                [oneTimeInvested]="oneTimeInvested"
                [monthlyInvested]="monthlyInvested"
                [iban]="iban"
              ></app-fund-summary>

              <ng-container *ngIf="currentAccountType !== '3a'; else is3AAccountOpened">
                <div *ngIf="customerData && accountOpened">
                  <div class="pending-fund-notice">
                    <p>{{ 'steps.id5.account_funded.as_soon_as' | translate }}</p>
                  </div>

                  <div class="pending-fund-notice">
                    <p>
                      <strong>{{ 'steps.id5.account_funded.invest_another_account_subtitle' | translate }}</strong>
                      <br />
                      {{ 'steps.id5.account_funded.invest_another_account_text' | translate }}
                      <a (click)="adaptSum()">{{ 'steps.id5.account_funded.invest_another_account_link' | translate }}</a>
                    </p>
                  </div>
                </div>
              </ng-container>
              <ng-template #is3AAccountOpened>
                <app-fund-3a-contribution-level-header
                  *ngIf="!isTransfer3AOnly"
                  [accountOpened]="accountOpened"
                  [currentYear]="currentYear"
                  [maximumContributionLevel]="maximumContributionLevel"
                  [maximumContributionAmount]="maximumContributionAmount"
                  [showUnemployed3ANote]="showUnemployed3ANote"
                  [customerData]="customerData"
                  [currentAccount]="currentAccount"
                ></app-fund-3a-contribution-level-header>

                <app-fund-3a-bank-details *ngIf="!isTransfer3AOnly" [currentAccount]="currentAccount"></app-fund-3a-bank-details>

                <div class="white-box title-box">
                  <h4>{{ 'steps.id5.account_to_fund.transfer_box.title' | translate }}</h4>
                </div>
                <div class="white-box section-details">
                  <app-transfer-3a-account></app-transfer-3a-account>
                </div>
              </ng-template>
            </div>

            <!-- 3A Footer -->
            <app-footer-3a *ngIf="currentAccountType === '3a'"></app-footer-3a>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-container>
